const DISMISSED_PREFIX = 'prairi.startupMessageTip.dismissed.';
const MESSAGED_PREFIX = 'prairi.startupMessageTip.messaged.';

/** After Follow, keep reviewing this long before the Message tip. */
export const STARTUP_MESSAGE_CALLOUT_AFTER_FOLLOW_MS = 6_000;

/** Open an already-messageable profile: wait this long if the Message button is visible. */
export const STARTUP_MESSAGE_CALLOUT_FIRST_VISIBLE_MS = 2_500;

export function hasDismissedStartupMessageCallout(userId: string): boolean {
  try {
    return window.localStorage.getItem(`${DISMISSED_PREFIX}${userId}`) === '1';
  } catch {
    return false;
  }
}

export function dismissStartupMessageCallout(userId: string): void {
  try {
    window.localStorage.setItem(`${DISMISSED_PREFIX}${userId}`, '1');
  } catch {
    // Private mode — tip still closes for this view.
  }
}

export function hasSentFounderMessage(userId: string): boolean {
  try {
    return window.localStorage.getItem(`${MESSAGED_PREFIX}${userId}`) === '1';
  } catch {
    return false;
  }
}

export function markSentFounderMessage(userId: string): void {
  try {
    window.localStorage.setItem(`${MESSAGED_PREFIX}${userId}`, '1');
  } catch {
    // Private mode — suppress only lasts this session via in-memory checks.
  }
}

export function shouldShowStartupMessageCallout(args: {
  isInvestor: boolean;
  messageButtonVisible: boolean;
  alreadyMessaged: boolean;
  dismissed: boolean;
  scrolledToFeeds: boolean;
  elapsedMs: number;
  requiredDelayMs: number;
}): boolean {
  if (!args.isInvestor || !args.messageButtonVisible) return false;
  if (args.alreadyMessaged || args.dismissed || args.scrolledToFeeds) return false;
  return args.elapsedMs >= args.requiredDelayMs;
}
